import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Emergency from "../../components/home/Emergency";
import EventBar from "../../components/home/EventBar";
import Partners from "../../components/home/Partners";
import QnA from "../../components/home/QnA";
import Service from "../../components/home/Service";

const Home = () => {
  return (
    <div className="relative w-full h-full">
      {/* 페이지 대표 H1 (페이지당 1개) - 접근성/SEO용 */}
      <h1 className="sr-only">
        SOS도어락열쇠프로 - 서울·경기·인천 24시간 도어락 교체·설치·수리 및 긴급출장
        열쇠 전문업체
      </h1>
      <Banner />
      <EventBar />
      <About />
      <Service />
      <Emergency />
      <QnA />
      {/*<Partners />*/}
    </div>
  );
};

export default Home;
